<template>
  <section class="pagos">
    <h2 class="wd-title pagos__title">Mantente al día y <br class="br-m"><span class="hl">protege tu avance</span></h2>

    <div class="wd-card pagos__notice">
      <img :src="iconPago" alt="" aria-hidden="true">
      <p class="wd-body">
        Sigue avanzando en tu financiamiento realiza tu pago puntual
        <strong>cada primer día hábil del mes.</strong>
      </p>
    </div>

    <div class="pagos__why">
      <p class="wd-body">Es importante porque:</p>
      <div class="pagos__items">
        <div v-for="item in items" :key="item" class="pagos__item">
          <span class="pagos__check"><img :src="checkPago" alt="" aria-hidden="true"></span>
          <p class="wd-body" v-html="item" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import iconPago from '../../../assets/bienvenida-desktop/icon-pago.svg'
import checkPago from '../../../assets/bienvenida-desktop/check-pago.svg'

const items = [
  'Mantienes tus beneficios',
  'Evitas cargos adicionales',
  'No afectas tu permanencia<br>en el sistema'
]
</script>

<style scoped>
.pagos {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-5);
  padding: var(--ds-space-5);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 24px;
}
.pagos__title { line-height: 40px; }
.pagos__notice { display: flex; align-items: center; gap: var(--ds-space-4); }
.pagos__notice img { flex: 0 0 40px; width: 40px; height: 40px; }
.pagos__notice strong { color: var(--ds-secondary-main); font-weight: 600; }
.pagos__why { display: flex; flex-direction: column; gap: var(--ds-space-4); }
.pagos__items { display: flex; gap: var(--ds-space-4); }
.pagos__item {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  gap: var(--ds-space-3);
  min-height: 56px;
  padding: 0 var(--ds-space-3);
  box-sizing: border-box;
}
.pagos__item:not(:last-child) { flex: 0 0 294px; }
.pagos__check { display: flex; flex: 0 0 24px; align-items: center; justify-content: center; width: 24px; height: 24px; }
.pagos__check img { width: 21px; height: 16px; }

@media (max-width: 1024px) {
  .pagos { gap: var(--ds-space-6); padding: var(--ds-space-6) var(--ds-space-4); }
  .pagos__why > .wd-body { min-height: 32px; display: flex; align-items: center; }
  .pagos__item,
  .pagos__item:not(:last-child) { flex: 1 1 0; min-height: 72px; padding: 0; }
  .pagos__check { flex-basis: 40px; width: 40px; height: 40px; }
}

@media (max-width: 599px) {
  .pagos { gap: var(--ds-space-5); padding: var(--ds-space-5) var(--ds-space-4); }
  .pagos__why > .wd-body { min-height: 24px; }
  .pagos__items { flex-direction: column; gap: var(--ds-space-5); }
  .pagos__item,
  .pagos__item:not(:last-child) { flex: none; min-height: 40px; }
}
</style>
